// Строки интерфейса — config/locales/frontend.<язык>.yml (ключи под frontend:), рядом с серверными
// переводами Rails; YAML превращается в JS при сборке (плагин vite.yaml.js). Язык — из
// <html lang>, его ставит layout по I18n.locale. Синтаксис как у Rails: %{name} — подстановка,
// one/few/many/other — формы для count.
const files = import.meta.glob("../../../config/locales/frontend.*.yml", { eager: true, import: "default" })
const translations = Object.assign({}, ...Object.values(files))

const FALLBACK = "ru"
export const locale = document.documentElement.lang in translations ? document.documentElement.lang : FALLBACK
const plurals = new Intl.PluralRules(locale)

function lookup(lang, key) {
  return key.split(".").reduce((node, part) => node?.[part], translations[lang]?.frontend)
}

export function t(key, params = {}) {
  let value = lookup(locale, key) ?? lookup(FALLBACK, key)
  if (value && typeof value === "object" && "count" in params) {
    value = value[plurals.select(params.count)] ?? value.other
  }
  if (typeof value !== "string") {
    if (import.meta.env.DEV) console.warn(`Нет перевода: ${locale}.frontend.${key}`)
    return key
  }
  return value.replace(/%\{(\w+)\}/g, (match, name) => (name in params ? String(params[name]) : match))
}
